import React from 'react';
import {
	Grid,
	Row,
	Col,
} from "react-bootstrap";
import { FiEye } from 'react-icons/fi';
import { Card } from "components/Card/Card.jsx";
import { withRouter } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import MessageCom from '../../layouts/Dashboard/Message';
import { userActions } from '../../redux/actions/user-actions';
import { connect } from 'react-redux';

class ChangePassword extends React.Component {
	constructor(props) {
		super(props);
		this.validatorUser = new SimpleReactValidator();
		let userAdmin;
		if (this.props.recover_account) {
			userAdmin = {}
		} else {
			userAdmin = JSON.parse(localStorage.getItem("user")).result.user;
		}
		this.state = {
			user: {
				...userAdmin,
				old_password: '',
				new_password: '',
				new_password_confirmation: ''
			},
			old_password_type: 'password',
			new_password_type: 'password',
			new_password_confirmation_type: 'password',
			submitted: false,
			formType: this.props.formTypePro || '',
		};
		this.handleUser = this.handleUser.bind(this);
		this.handleUserSubmitForm = this.handleUserSubmitForm.bind(this);
	}
	handleUser(e) {
		const { name, value } = e.target;
		const userState = { ...this.state.user };
		userState[name] = value;
		this.setState({ user: userState });
	}
	handleUserSubmitForm(e) {
		e.preventDefault();
		if (this.validatorUser.allValid()) {
			let user;
			if (this.props.recover_account) {
				user = {
					new_password: this.state.user.new_password,
					new_password_confirmation: this.state.user.new_password_confirmation,
					token: this.props.match.params.bearer
				}
				this.props.resetUserPasswordCall(user).then(res => {
					if (res.status === 'success')
						this.props.history.push('/');
				})
			}
			else {
				user = {
					old_password: this.state.user.old_password,
					new_password: this.state.user.new_password,
					new_password_confirmation: this.state.user.new_password_confirmation
				}
				this.props.changePasswordCall(this.state.user.id, user).then(res => {
					if (res.status === 'success')
						this.props.history.goBack();
				})
			}

		} else {
			this.setState({ submitted: false });
			this.validatorUser.showMessages();
			this.forceUpdate();
		}
	}

	handleMouseDown = name => {
		// let frag = document.createRange().createContextualFragment(e.target);
		// console.log('down', name)
		this.setState({
			...this.state,
			[name]: 'text'
		})
	}

	handleMouseUp = name => {
		// let frag = document.createRange().createContextualFragment(e.target);
		// console.log('up', frag.children[0].name)
		this.setState({
			...this.state,
			[name]: 'password'
		})
	}
	render() {
		const { user, old_password_type, new_password_type, new_password_confirmation_type } = this.state;
		return (
			<div>
				{
					this.props.recover_account &&
					<MessageCom />
				}
				<Grid fluid>
					<Row>
						<Col md={12}>
							<Card
								className="mt-lg"
								ctTableResponsive
								content={
									<div>
										<Grid fluid>
											<Row>
												<Col md={12}>
													<div className="col-md-4 col-md-offset-4">
														<form onSubmit={this.handleUserSubmitForm}>
															{
																!this.props.recover_account &&
																<h4>User Name: {user.user_name}</h4>
															}

															<div className="col-md-12">
																{
																	!this.props.recover_account &&
																	<div className='form-group relativeCard'>
																		<label className="mb-xs mt-sm" htmlFor="old_password">Old Password<span className="requiredClass">*</span></label>
																		<input type={old_password_type} autoComplete="off" name="old_password" className="form-control password_icon" value={user.old_password} onChange={this.handleUser} minLength="6" />
																		{
																			this.validatorUser.message('password', user.old_password, 'required|min:6')
																		}

																		<span className="showPass iconsClearfix" name='old_password_type' onMouseDown={e => { this.handleMouseDown('old_password_type') }} onMouseUp={(e) => { this.handleMouseUp('old_password_type') }} onMouseOut={(e) => { this.handleMouseUp('old_password_type') }}>
																			<FiEye name='old_password_type' />
																		</span>
																	</div>
																}
																<div className='form-group relativeCard'>
																	<label className="mb-xs mt-sm" htmlFor="new_password">New Password<span className="requiredClass">*</span></label>
																	<input type={new_password_type} autoComplete="off" name="new_password" className="form-control password_icon" value={user.new_password} onChange={this.handleUser} minLength="6" />
																	{
																		this.validatorUser.message('password', user.new_password, 'required|min:6')
																	}

																	<span className="showPass iconsClearfix" name='new_password_type' onMouseDown={e => { this.handleMouseDown('new_password_type') }} onMouseUp={(e) => { this.handleMouseUp('new_password_type') }} onMouseOut={(e) => { this.handleMouseUp('new_password_type') }}>
																		<FiEye />
																	</span>
																</div>
																<div className='form-group relativeCard'>
																	<label className="mb-xs mt-sm" htmlFor="new_password_confirmation">Confirm New Password<span className="requiredClass">*</span></label>
																	<input type={new_password_confirmation_type} autoComplete="off" name="new_password_confirmation" className="form-control password_icon" value={user.new_password_confirmation} onChange={this.handleUser} />
																	{
																		this.validatorUser.message('confirm_password', user.new_password_confirmation, 'required|min:6')
																	}

																	<span className="showPass iconsClearfix" name='new_password_confirmation_type' onMouseDown={e => { this.handleMouseDown('new_password_confirmation_type') }} onMouseUp={(e) => { this.handleMouseUp('new_password_confirmation_type') }} onMouseOut={(e) => { this.handleMouseUp('new_password_confirmation_type') }}>
																		<FiEye />
																	</span>
																</div>
															</div>

															<div className="col-md-12">
																<div className='text-center flexElem'>
																	{
																		this.props.recover_account &&
																		<button onClick={() => { this.props.history.push('/') }} type='button' className="customBtn btnBlack m-sm">Back to Home</button>
																	}
																	{
																		!this.props.recover_account &&
																		<button onClick={() => { this.props.history.goBack() }} type='button' className="customBtn btnBlack m-sm">Go Back</button>
																	}
																	<button type='submit' className="customBtn btnBlue m-sm">Save</button>
																</div>
															</div>
															<span></span>
														</form>
													</div>
												</Col>
											</Row>
										</Grid>
									</div>
								} />
						</Col>
					</Row>
				</Grid>
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return ({
		changePasswordCall: (id, data) => { return dispatch(userActions.changeUserPassword(id, data)) },
		resetUserPasswordCall: (data) => { return dispatch(userActions.resetUserPassword(data)) },
	});
};

export default withRouter(connect(null, mapDispatchToProps)(ChangePassword));


// WEBPACK FOOTER //
// ./src/components/Admin/ChangePassword.jsx